/**
 * @coeldery/chat-composer — 自動增高嘅**純函數**（唔掂 DOM → 可直接單測）
 *
 * ⭐ 1.4.0（2026-09-22 產品負責人；`decisions/023`）：
 *   輸入框要「**一次過顯示全部內容，唔好喺細框內上下捲**」—— 但為咗唔遮住對話，
 *   高度要有**上限**（預設螢幕 40% 高）→ 超過才喺框內捲。
 *   呢三個函數就係嗰條數學（唔准寫喺 component 內：唔可以測）。
 */
export const COMPOSER_MIN_H = 48;

/** 由螢幕高度算上限（百分比）。離譜值 → 退回 40%；再少都要有 160px */
export function composerMaxHeight(viewportHeight: number, vhPercent = 40): number {
  const pct = Number.isFinite(vhPercent) && vhPercent > 0 && vhPercent <= 100 ? vhPercent : 40;
  const vh = Number.isFinite(viewportHeight) && viewportHeight > 0 ? viewportHeight : 800;
  return Math.max(160, Math.round((vh * pct) / 100));
}

/** 目標高度：夠高顯示全部內容（`scrollHeight`），封頂於 `maxHeight`，唔低過 `minHeight` */
export function composerHeightFor(scrollHeight: number, maxHeight: number, minHeight = COMPOSER_MIN_H): number {
  if (!Number.isFinite(scrollHeight) || scrollHeight <= 0) return minHeight;
  const cap = Math.max(minHeight, maxHeight);
  return Math.min(Math.max(scrollHeight, minHeight), cap);
}

/** 要唔要框內捲（＝內容高過上限）—— 只有呢種情況才准 `overflow-y: auto` */
export function needsInnerScroll(scrollHeight: number, maxHeight: number): boolean {
  return scrollHeight > Math.max(COMPOSER_MIN_H, maxHeight) + 1;
}
